import _objectSpread from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["id", "equipments", "gifId", "videoId", "imageId"];
import { deleteExerciseApiCall, getAiExercisesApiCall, getExercisesApiCall, getExercisesByIdsApiCall, saveExerciseApiCall } from '@guryou/api-client-gql';
import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';
export const EXERCISES_GET = {
  entity: 'EXERCISES',
  action: Action.GET
};
export const CREATE_EXERCISE = {
  entity: 'EXERCISE',
  action: Action.CREATE
};
export const UPDATE_EXERCISE = {
  entity: 'EXERCISE',
  action: Action.UPDATE
};
export const ARCHIVE_EXERCISE = {
  entity: 'ARCHIVE_EXERCISE',
  action: Action.HANDLE
};
export const EXERCISES_GET_BY_IDS = {
  entity: 'EXERCISES',
  action: Action.GET
};
export const UPDATE_EXERCISE_V2 = {
  entity: 'EXERCISE_V2',
  action: Action.UPDATE
};
export const AI_EXERCISES = {
  entity: 'AI_EXERCISES',
  action: Action.GET_MANY
};
export const getExercises = () => async dispatch => execute(dispatch, () => getExercisesApiCall({
  equipments: ['id', 'equipmentId', 'weight', 'weightMode', 'quantity', 'name'],
  image: ['name', 'thumbnailUrl'],
  gif: ['name', 'thumbnailUrl'],
  video: ['name', 'thumbnailUrl']
}), EXERCISES_GET);
export const getExercisesByIds = ids => async dispatch => execute(dispatch, () => getExercisesByIdsApiCall({
  ids
}, {
  image: ['name', 'thumbnailUrl'],
  gif: ['name', 'thumbnailUrl'],
  video: ['name', 'thumbnailUrl']
}), EXERCISES_GET_BY_IDS);
export const saveExercise = _ref => {
  let {
      id,
      equipments,
      gifId,
      videoId,
      imageId
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return async dispatch => {
    const request = _objectSpread(_objectSpread({}, rest), {}, {
      id: id || null,
      gifId: gifId || null,
      videoId: videoId || null,
      imageId: imageId || null,
      equipments: equipments === null || equipments === void 0 ? void 0 : equipments.map(x => _objectSpread(_objectSpread({}, x), {}, {
        id: x.id || null,
        weightMode: x.weightMode || null,
        weight: +x.weight,
        quantity: +x.quantity
      }))
    });
    execute(dispatch, () => saveExerciseApiCall({
      request
    }), UPDATE_EXERCISE);
  };
};

// export const saveExerciseV2 = ({ id, equipment_ids, gifId, videoId, imageId, ...rest }) => async dispatch => {
//   const transformedData = {
//     ...rest,

//     id: id || null,

//     image_id: imageId || null,
//     video_id: videoId || null,
//     gif_id: gifId || null,

//     equip_settings: equipment_ids ? { equipment_ids: equipment_ids } : null,
//   };

//   return execute(dispatch, () => saveExerciseV2ApiRequest(transformedData), UPDATE_EXERCISE_V2);
// };

export const archiveExercise = id => async dispatch => execute(dispatch, () => deleteExerciseApiCall({
  id
}), ARCHIVE_EXERCISE);
export const getAiExercises = _ref2 => {
  let {
    levels,
    muscleAreas
  } = _ref2;
  return async dispatch => {
    execute(dispatch, () => getAiExercisesApiCall({
      levels,
      muscleAreas
    }, {
      image: ['name', 'thumbnailUrl']
    }), AI_EXERCISES);
  };
};
export const exercisesReducer = {
  all: basicReducer(EXERCISES_GET),
  archive: basicReducer(ARCHIVE_EXERCISE),
  save: basicReducer(UPDATE_EXERCISE),
  saveV2: basicReducer(UPDATE_EXERCISE_V2),
  byIds: basicReducer(EXERCISES_GET_BY_IDS),
  aiExercises: basicReducer(AI_EXERCISES)
};